import { Button } from "@shared/ui/Button";
import { Image } from "@shared/ui/Image";

export type Props = {
  label: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  className?: string;
};

export function GoogleButton({
  label,
  onClick,
  isLoading = false,
  className,
  ...props
}: Props) {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={isLoading}
      data-testid="google-button"
      className={className}
      {...props}
    >
      <span className="inline-flex items-center justify-center gap-2">
        {isLoading ? (
          <>
            <div className="w-4 h-4 border-2 border-brand-400 border-t-transparent rounded-full animate-spin animate-spin-slow" />
            Loading...
          </>
        ) : (
          <>
            <Image
              src="https://mnma.imgix.net/projects/pollinator/google-logo.png"
              alt="Google"
              className="w-4"
            />{" "}
            {label}
          </>
        )}
      </span>
    </Button>
  );
}

export default GoogleButton;
